import { Processes } from "@/routes/processes/_components/processes";
import { MainPageContent } from "@/routes/_components/main-page";
import { Outlet } from "react-router";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { Alert403 } from "@/shared/components/alerts/alert-403";

export function ProcessesRoute() {
  const canAccess = useFeatureAuth("gsm.processes");
  if (!canAccess) {
    return (
      <MainPageContent>
        <Alert403 />
      </MainPageContent>
    );
  }

  return <Outlet />;
}

export function ProcessesIndexRoute() {
  return (
    <MainPageContent>
      <Processes />
    </MainPageContent>
  );
}
